import { type ComputedRef, computed } from 'vue';
import { useIsMobilePhone } from '@/composables/useIsMobilePhone';
import { useMobilePreferences } from '@/composables/useMobilePreferences';

// Shared gate for the mobile experience: a phone and not opted into the full version.
export function useShowMobileView(): ComputedRef<boolean> {
  const isMobilePhone = useIsMobilePhone();
  const { prefersDesktop } = useMobilePreferences();
  return computed(() => isMobilePhone.value && !prefersDesktop.value);
}
